import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { MonitoringRegimeDefaultsState } from "../../models/mp-admin/monitoring-regime-defaults-state";

const initialState: MonitoringRegimeDefaultsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.monitoringRegimeDefaults.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.monitoringRegimeDefaults.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.monitoringRegimeDefaults.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.monitoringRegimeDefaults.invalidate, () => initialState)
);

export function monitoringRegimeDefaultsReducer(
	state: MonitoringRegimeDefaultsState | undefined,
	action: Action
): MonitoringRegimeDefaultsState {
	return reducer(state, action);
}
